import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

function ClosureInfo(props) {
    let from, until = '';
    if (props.deactivatedInFsf) {
        const fromParts = props.deactivatedInFsfFrom.split('-');
        const untilParts = props.deactivatedInFsfUntil.split('-');
        from = fromParts[2] + '/' + fromParts[1] + '/' + fromParts[0];
        until = untilParts[2] + '/' + untilParts[1] + '/' + untilParts[0];
    }

    return (
        props.deactivatedInFsf ?
        <div className="fsf-station fsf-station__closure_info">
            <Translation
                translationKey="fitting-station-closure-message"
                placeholder={{ FROM: from, UNTIL: until}}
            />
        </div> : ''
    );
}

ClosureInfo.propTypes = {
    deactivatedInFsf: PropTypes.bool.isRequired,
    deactivatedInFsfFrom: PropTypes.string.isRequired,
    deactivatedInFsfUntil: PropTypes.string.isRequired,
};

ClosureInfo.defaultProps = {
    deactivatedInFsf: false,
};

export default ClosureInfo;
